import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slices/cartSlice';
import favoritesReducer from './slices/favoritesSlice';
import authReducer from './slices/authSlice';
import proposalsReducer from './slices/proposalsSlice';
import newsReducer from './slices/newsSlice';
import salesReducer from './slices/salesSlice';
import categoriesReducer from './slices/categoriesSlice';
import artworksReducer from './slices/artworksSlice';
import userReducer from './slices/userSlice';
import statsReducer from './slices/statsSlice';
import globalLoadingReducer from './slices/globalLoadingSlice';
import commentsReducer from './slices/commentsSlice';
// Optimized middleware imports
import cartPersistenceMiddleware from './middleware/cartPersistenceMiddleware';

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    wishlist: favoritesReducer,
    auth: authReducer,
    proposals: proposalsReducer,
    news: newsReducer,
    sales: salesReducer,
    categories: categoriesReducer,
    artworks: artworksReducer,
    user: userReducer,
    stats: statsReducer,
    global_loading: globalLoadingReducer,
    comments: commentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
    .concat(cartPersistenceMiddleware),
});